
import { createContext } from 'react';
import { Resource, Category, SubTopic, AppSettings } from '../types/resource';

interface ResourcesContextType {
  categories: Category[];
  resources: Resource[];
  isAdmin: boolean;
  settings: AppSettings;
  login: (username: string, password: string) => Promise<boolean>;
  logout: () => void;
  changeCredentials: (newUsername: string, newPassword: string) => void;
  toggleDeveloperMode: () => void;
  addCategory: (category: Omit<Category, 'id'>) => void;
  updateCategory: (id: string, category: Partial<Category>) => void;
  deleteCategory: (id: string) => void;
  addResource: (resource: Omit<Resource, 'id'>) => void;
  updateResource: (id: string, resource: Partial<Resource>) => void;
  deleteResource: (id: string) => void;
  addSubTopic: (resourceId: string, subTopic: Omit<SubTopic, 'id'>) => void;
  removeSubTopic: (resourceId: string, subTopicId: string) => void;
  updateSubTopic: (resourceId: string, subTopicId: string, updates: Partial<SubTopic>) => void;
  getResourcesByCategory: (categoryId: string) => Resource[];
  getResourceById: (id: string) => Resource | undefined;
  getDefaultResource: (id: string) => Resource | undefined;
  getCategoryById: (id: string) => Category | undefined;
  _timestamp: number;
}

export const ResourcesContext = createContext<ResourcesContextType | undefined>(undefined);

// Re-export the types from the types file
export type { Resource, Category, SubTopic, AppSettings } from '../types/resource';
